import React from 'react'
import { IEnquiryDetail } from '../../../models/Enquiry'
import { getEnquiry } from '../EnquiryCommon'

const { createContext, useState } = React

interface IEnquiryContext {
  enquiry: IEnquiryDetail
  reload: () => void
}

type Props = {
  enquiry: IEnquiryDetail
  children: React.ReactNode
  handleErrors?: (any) => void
}

export const EnquiryContext = createContext<IEnquiryContext>({
  enquiry: null,
  reload: async () => {
    // do nothing
  },
})

export const EnquiryDetailProvider = (props: Props) => {
  const reload = async () => {
    getEnquiry(state.enquiry.id)
      .then((data) => {
        update((prev) => ({
          ...prev,
          enquiry: data,
        }))
      })
      .catch((error) => {
        props.handleErrors(error)
      })
  }

  const [state, update] = useState<IEnquiryContext>({
    enquiry: props.enquiry,
    reload: reload,
  })

  return (
    <EnquiryContext.Provider value={state}>
      {props.children}
    </EnquiryContext.Provider>
  )
}

export default EnquiryContext
